module.exports = __webpack_public_path__ + "img/wallet_02_evm_1.947b36dd.png";